const SET_ERROR = "SET_ERROR";
const CLEAR_ERROR = "CLEAR_ERROR";

const ErrorSymbols = {
  SET_ERROR,
  CLEAR_ERROR,
};
export default ErrorSymbols;
